// Lightweight i18n for English + Arabic. Keep keys short and descriptive.
export const LANGS = { en: "English", ar: "العربية" };

export const STRINGS = {
  en: {
    "app.brand": "Aviary Studio",
    "app.tagline": "Breeding Schedules",
    "common.save": "Save",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.close": "Close",
    "common.cancel": "Cancel",
    "common.signin": "Sign in",
    "common.signup": "Create account",
    "common.email": "Email",
    "common.password": "Password",
    "common.name": "Name",
    "common.loading": "Loading…",
    "common.updated": "Updated",
    "common.clear": "Clear",
    "common.reset": "Reset row",
    "common.confirm": "Confirm",
    "common.language": "Language",
    "common.you": "You",
    "common.back": "Back",
    "auth.welcome": "Welcome back",
    "auth.signin_sub": "Sign in to continue managing your breeding schedules.",
    "auth.signup_title": "Create an account",
    "auth.signup_sub": "Start tracking your breeding pairs in minutes.",
    "auth.new_to": "New to Aviary Studio?",
    "auth.have_account": "Already have an account?",
    "auth.password_min": "Password (min 6 chars)",
    "nav.couples": "Couples",
    "nav.logout": "Logout",
    "nav.birds": "Birds Registry",
    "nav.pedigree": "Pedigree",
    "nav.courses": "Supplements & Recovery",
    "sync.synced": "Synced",
    "sync.syncing": "Syncing…",
    "sync.offline": "Offline",
    "group.label": "Season",
    "group.switch": "Switch season",
    "group.invite_code": "Invite code",
    "group.copy": "Copy",
    "group.copied": "Copied",
    "group.members": "Members",
    "group.settings": "Season settings",
    "group.new_join": "New / Join season",
    "groups.landing_add": "Add another season",
    "groups.landing_first": "Create or join a breeding season",
    "groups.landing_sub": "Each season has its own schedules synced across every member. Share the invite code with collaborators.",
    "groups.intro_title": "Welcome to BREEDERS & TRACKING APP",
    "groups.intro_body": "An app, real-time schedule for breeders. Track all your couples and register all your chicks per season — eggs, hatch dates, chick ring numbers, mutations, and parentage all stay synced live across phone and computer. Share a season with your team using a single invite code.",
    "groups.intro_pt_1": "Live multi-device sync — works offline too",
    "groups.intro_pt_2": "Egg put to egg hatch — tracking egg hatch with a reminder",
    "groups.intro_pt_3": "Bilingual EN / AR · printable & CSV exports",
    "groups.intro_pt_4": "Track your birds incubation period and choose the birds species between canary, budgie, lovebird, cockatiel, zebra finch and parrot",
    "nav.market": "Birds Market",
    "market.title": "Birds Market",
    "market.sub": "Buy and sell birds with other breeders — open an offer to see photos, video, description and contact details",
    "market.selling": "Selling Birds",
    "market.selling_sub": "Birds offered for sale by breeders",
    "market.buying": "Buying Birds",
    "market.buying_sub": "Birds that breeders are looking to buy",
    "market.add_bird": "Add Bird",
    "market.edit_offer": "Edit offer",
    "market.all_species": "All species",
    "market.species": "Species",
    "market.species_canary": "Canary",
    "market.species_budgie": "Budgie",
    "market.species_lovebird": "Lovebird",
    "market.species_cockatiel": "Cockatiel",
    "market.species_zebra_finch": "Zebra Finch",
    "market.species_parrot": "Parrot",
    "market.species_other": "Other",
    "market.offer_title": "Title",
    "market.description": "Description & contact",
    "market.description_hint": "Describe the bird(s): age, sex, ring, color, price… and add your contact number so people can reach you.",
    "market.media": "Photos / video",
    "market.media_hint": "Up to {n} photos ({i} MB each) and 1 video ({v} MB max)",
    "market.browse": "Browse files",
    "market.upload": "Upload",
    "market.uploading": "Uploading…",
    "market.published": "Offer published",
    "market.saved": "Offer saved",
    "market.deleted": "Offer deleted",
    "market.reopened": "Offer reopened",
    "market.empty": "No offers yet — be the first to add one.",
    "market.not_found": "This offer no longer exists.",
    "market.files": "file(s)",
    "market.replies": "admin reply(s)",
    "market.copy": "Copy",
    "market.sold": "SOLD",
    "market.bought": "BOUGHT",
    "market.mark_sold": "Mark as Sold",
    "market.mark_bought": "Mark as Bought",
    "market.mark_open": "Reopen offer",
    "market.delete_title": "Delete this offer?",
    "market.delete_body": "The offer and its photos/video will be removed from the market.",
    "market.reply_placeholder": "Admin reply (e.g. please mark as sold if the bird is gone)",
    "market.err_max_images": "Maximum {n} photos per offer",
    "market.err_image_size": "Each photo must be under {n} MB",
    "market.err_one_video": "Only one video per offer",
    "market.err_video_size": "Video must be under {n} MB",
    "market.err_type": "Only photos and videos are allowed",
    "market.err_upload": "Upload failed, please try again",
    "market.search_placeholder": "Search offers by title, description or breeder…",
    "market.no_results": "No offers match your search or filter.",
    "market.follow": "Notify me about {s}",
    "market.unfollow": "Stop notifications for {s}",
    "market.followed": "You'll get a push alert when a new offer appears",
    "market.unfollowed": "Notifications turned off",
    "market.mine": "My Offers",
    "market.mine_sub": "All your sell & buy offers in one place — mark them sold/bought, edit or remove",
    "market.mine_empty": "You have no offers here.",
    "market.status_open": "OPEN",
    "market.age_days": "{n} days old",
    "market.stale_tag": "Older than 30 days",
    "market.filter_all": "All",
    "market.filter_pending": "Pending",
    "market.filter_done": "Sold / Bought",
    "market.filter_sold": "Sold",
    "market.filter_bought": "Bought",
    "market.sort_new": "Newest",
    "market.sort_old": "Oldest",
    "domain.title": "We've moved to breedtrackers.com",
    "domain.body": "Please use the new address from now on — same account, same data. Add it to your home screen for quick access.",
    "domain.open": "Open breedtrackers.com",
    "common.refresh": "Refresh",
    "stale.title": "Stale market offers",
    "stale.sub": "{n} pending offer(s) older than 30 days · {o} open in total",
    "stale.sub_loading": "Loading…",
    "stale.empty": "No pending offers older than 30 days.",
    "stale.owner": "Owner",
    "stale.age": "Age",
    "stale.last_reminded": "Last reminded",
    "stale.never": "never",
    "stale.remind": "Remind owner",
    "stale.run_now": "Send due reminders",
    "stale.ran": "Reminders sent: {n}",
    "stale.done": "Done",
    "stale.reminded": "Reminder sent to the owner (message, push & email)",
    "stale.failed": "Action failed",
    "groups.intro_pt_5": "Get 7 days free subscription after creating an account",
    "groups.intro_pt_7": "If you like the app you can subscribe — subscriptions are within everyone's reach",
    "groups.intro_pt_6": "Head to the Suggestions & Complaints page in Settings — we look after your suggestions and try to solve your problems",
    "groups.intro_pt_8": "If you deleted a season or the account by mistake contact me and I can restore it for you",
    "groups.intro_pt_9": "Keep your season file on your phone or PC? Afraid your phone might break or the file might get corrupted and you lose everything? Try Breeders Tracking App — you won't lose any data.",
    "groups.intro_pt_10": "With Breeders Tracking App, everything a breeder needs is in one place: logging couples, registering chicks with foot rings, supplement and recovery courses, and even bird pedigrees. Try it and you won't regret it.",
    "share.button": "Share",
    "share.title": "Share this card",
    "share.cta": "Try it free for 7 days",
    "share.scan": "Scan the code or open the link to start",
    "share.msg": "Breeders Tracking App — keep all your breeding seasons safe in one place. Try it free:",
    "share.share": "Share",
    "share.download": "Download image",
    "share.copy_link": "Copy link",
    "share.copied": "Link copied",
    "share.downloaded": "Image downloaded and link copied — paste them into your post",
    "share.failed": "Could not create the image, please try again",
    "share.desktop_hint": "Message copied — paste it in your post",
    "share.desktop_hint_img": "Image downloaded and caption copied — attach them to your post",
    "bcast.title": "Email all users",
    "bcast.sub": "Send a bilingual announcement to every registered user ({n} recipients). Pre-filled with the new-address notice.",
    "bcast.subject": "Subject",
    "bcast.test_placeholder": "Send a test to this email first",
    "bcast.send_test": "Send test",
    "bcast.send_all": "Send to all ({n})",
    "bcast.test_sent": "Test email sent",
    "bcast.started": "Sending started — progress is shown below",
    "bcast.confirm_title": "Send to everyone?",
    "bcast.confirm_body": "This will email all {n} registered users. This cannot be undone.",
    "bcast.confirm_yes": "Yes, send to all",
    "bcast.done": "Done",
    "bcast.running": "Sending",
    "bcast.queued": "Queued",
    "bcast.interrupted": "Interrupted",
    "bcast.failed": "failed",
    "bcast.retry": "Retry failed",
    "bcast.retry_label": "retry",
    "bcast.last_error": "Last error",
    "bcast.health_ok": "Email service ready — key valid, sender domain verified",
    "bcast.health_bad": "Email service problem",
    "elog.title": "Email delivery log",
    "elog.sub": "Every email the app sent — automatic and manual — with delivered or failed status",
    "elog.total_30d": "Sent (30 days)",
    "elog.delivered": "Delivered",
    "elog.failed": "Failed",
    "elog.all": "All",
    "elog.empty": "No emails logged yet.",
    "elog.col_time": "Time",
    "elog.col_kind": "Type",
    "elog.col_to": "To",
    "elog.col_subject": "Subject",
    "elog.col_status": "Status",
    "elog.ok": "Delivered",
    "elog.fail": "Failed",
    "elog.kind_warning": "Renewal warning",
    "elog.kind_gift_reminder": "Gift code reminder",
    "elog.kind_broadcast": "Announcement",
    "elog.kind_broadcast_test": "Announcement test",
    "elog.kind_admin_notice": "Admin alert",
    "elog.kind_admin_message": "Admin email",
    "elog.kind_password_reset": "Password reset",
    "elog.kind_other": "Other",
    "lb.title": "Referral leaderboard",
    "lb.sub": "Top inviting breeders and the free days given out",
    "lb.inviters": "Breeders who invited",
    "lb.signups": "Joined via links",
    "lb.subscribed": "Of them subscribed",
    "lb.days_given": "Free days given",
    "lb.empty": "No referrals yet.",
    "lb.breeder": "Breeder",
    "lb.col_signups": "Invited",
    "lb.col_subscribed": "Subscribed",
    "lb.col_days": "Days earned",
    "lb.leader_title": "Leading this month",
    "lb.no_leader": "No invites yet this month",
    "lb.bonus_note": "On the 1st of each month the top inviter gets a badge and +{d} bonus free days.",
    "badge.top_inviter": "Top inviter",
    "badge.top_inviter_hint": "Top inviter of the month — thank you for growing the community!",
    "badge.leading": "Leading this month",
    "ref.monthly_bonus": "Each month's top inviter also gets a badge and 10 bonus free days.",
    "groups.intro_pt_11": "Every breeder has a personal referral link: every 5 new breeders who join through your link earn you 3 free days, and if 3 of those 5 subscribe you earn 5 more free days. Each month's top inviter also gets a badge and 10 bonus free days.",
    "groups.intro_pt_12": "With Breeders Tracking App you can now list your birds for sale or place a purchase request in the Birds Market.",
    "groups.intro_pt_13": "The official app link:",
    "ref.title": "Invite & earn",
    "ref.sub": "Share your personal link with breeder friends and earn free days",
    "ref.rules": "Every {n} new breeders who join through your link earn you {d1} free days. If {k} of those {n} subscribe, you earn {d2} more free days.",
    "ref.share_msg": "Join me on Breeders Tracking App — keep all your breeding seasons safe in one place. Sign up with my link and try it free for 7 days:",
    "ref.stat_signups": "Joined via your link",
    "ref.stat_subscribed": "Of them subscribed",
    "ref.stat_next": "More to next reward",
    "ref.stat_days": "Free days earned",
    "ref.list_title": "Your invitees",
    "ref.empty": "Nobody has joined through your link yet — share it!",
    "ref.subscribed": "Subscribed",
    "ref.joined": "Joined",
    "ref.reward_signup": "+{d} days — 5 new breeders (group {b})",
    "ref.reward_sub": "+{d} days — 3 of group {b} subscribed",
    "ref.invited_by": "You were invited by {name} — welcome!",
    "ref.earn_link": "Invite friends and earn free days",
    "groups.featured_reviews_title": "What our users say",
    "stats.eggs": "Eggs",
    "stats.hatched": "Hatched",
    "stats.rate": "Hatch rate",
    "stats.pairs": "Active pairs",
    "activity.title": "User Activity",
    "activity.sub": "Who is online, when they logged in, and what they did",
    "activity.online": "Online",
    "activity.offline": "Offline",
    "activity.last_login": "Last login",
    "activity.duration": "Session",
    "activity.actions": "Recent actions",
    "activity.none": "No recorded actions yet.",
    "activity.refresh": "Refresh",
    "activity.kind_login": "Logged in",
    "activity.kind_couple": "Updated couple",
    "activity.kind_bird": "Updated bird",
    "drip.title": "Renewal countdown",
    "drip.sub": "Expired accounts, their warning stage, and days left before auto-delete",
    "drip.run": "Run check now",
    "drip.ran": "Check done: {sent} email(s) sent, {deleted} account(s) deleted",
    "drip.empty": "No expired accounts right now.",
    "drip.expired_for": "Expired {d} days ago",
    "drip.stage": "Stage",
    "drip.stage_none": "Not warned yet",
    "drip.stage_n": "Warning {n} of 4",
    "drip.next_in": "Next email in {d} days",
    "drip.delete_in": "Delete in {d} days",
    "drip.delete_due": "Deletion due",
    "drip.last_sent": "Last email",
    "drip.code": "Gift code",
    "drip.code_used": "used",
    "drip.code_unused": "unused",
    "drip.reminded": "reminder sent",
    "drip.stats_title": "This month",
    "drip.stat_countdown": "In countdown",
    "drip.stat_warnings": "Warnings sent",
    "drip.stat_reminders": "Code reminders",
    "drip.stat_deleted": "Auto-deleted",
    "drip.stat_comebacks": "Came back",
    "drip.stat_renewed": "Renewed",
    "comeback.title": "Comebacks",
    "comeback.sub": "Users who returned after a renewal warning, and whether they renewed",
    "comeback.empty": "Nobody has come back yet.",
    "comeback.type_restored": "Account restored",
    "comeback.type_login_after_warning": "Logged in after warning",
    "comeback.type_renewed": "Renewed after warning",
    "comeback.after_stage": "after warning {n}",
    "comeback.returned": "Returned",
    "comeback.renewed": "Renewed",
    "comeback.not_renewed": "Not renewed yet",
    "comeback.gone": "Deleted again",
    "welcome_back.title": "Welcome back, {name}!",
    "welcome_back.body": "Your account and all your seasons have been restored. Renew your subscription to continue where you left off.",
    "welcome_back.renew": "Renew now",
    "drip.plan": "Plan",
    "drip.plan_none": "no subscription",
    "bulk.add": "Bulk add",
    "bulk.delete": "Delete",
    "bulk.delete_confirm": "Delete the selected lines? Their data will be removed.",
    "bulk.added": "Lines added",
    "bulk.deleted": "Lines deleted",
    "sub.badge_label": "Subscription",
    "sub.teaser_title": "Try free for 7 days",
    "sub.teaser_body": "Your account starts with a 7-day free trial. After that, pick a plan that fits your aviary. Pay with PayPal or BenefitPay (Bahrain).",
    "sub.plan_1m_label": "1 month",
    "sub.plan_3m_label": "3 months",
    "sub.plan_6m_label": "6 months",
    "sub.plan_1y_label": "1 year",
    "sub.plan_1y_save": "Best value",
    "sub.teaser_view": "View subscription plans",
    "footer.copyright": "© {year} Aviary Studio · All rights reserved.",
    "footer.tagline": "Built for breeders, by a breeder.",
    "auth.social_divider": "Or continue with",
    "auth.social_coming_soon": "{provider} sign-in is coming soon — please use email or Google for now.",
    "auth.google_button": "Continue with Google",
    "auth.delete_account": "Delete my account",
    "auth.delete_account_btn": "Delete account",
    "auth.delete_account_title": "Permanently delete your account?",
    "auth.delete_account_body": "This will delete your profile, owned seasons, subscriptions, photos and notifications. Admins can restore deleted seasons within 30 days. Type DELETE below to confirm.",
    "auth.delete_account_confirm_label": "Type DELETE to confirm",
    "auth.delete_account_yes": "Yes, delete forever",
    "auth.delete_account_no": "Cancel",
    "auth.delete_account_success": "Account deleted. Goodbye 👋",
    "admin.delete_user_btn": "Delete",
    "admin.delete_user_title": "Delete user {email}?",
    "admin.delete_user_body": "This permanently removes the user, their owned seasons (snapshots kept for recovery), subscriptions, photos and notifications. They will be logged out everywhere. Continue?",
    "admin.delete_user_yes": "Yes, delete",
    "admin.delete_user_no": "Cancel",
    "admin.delete_user_success": "User {email} deleted",
    "admin.deleted_users": "Deleted users (recovery)",
    "admin.deleted_users_empty": "No deleted users. When a user account is deleted, it appears here for recovery within 30 days.",
    "admin.deleted_user_email_col": "Email",
    "admin.deleted_user_role_col": "Role",
    "admin.deleted_user_pwd_col": "Password kept",
    "admin.restore_user_btn": "Restore",
    "admin.restore_user_confirm": "Restore user {email}? Their original password will still work (or they can use Google if that's how they signed in). Owned seasons must be restored separately from the deleted-groups section.",
    "admin.restore_user_success": "Restored {email} — original password still works",
    "sub.try_benefitpay": "Try BenefitPay instead",
    "groups.create": "Create",
    "groups.join": "Join with code",
    "groups.name_label": "Season name",
    "groups.name_placeholder": "e.g. Season 2026, Canaries A1",
    "groups.create_btn": "Create season",
    "groups.join_btn": "Join season",
    "groups.code_label": "Invite code",
    "groups.your_groups": "Your seasons",
    "groups.open": "Open",
    "couples.title": "Breeding Couples",
    "couples.sub": "6 egg dates · 6 chick slots · auto-saves on blur",
    "couples.male": "Male mutation",
    "couples.jump_pair": "Go to pair…",
    "couples.female": "Female mutation",
    "couples.male_placeholder": "♂ Male mutation",
    "couples.female_placeholder": "♀ Female mutation",
    "couples.egg": "Egg",
    "couples.egg_dates": "Egg dates",
    "couples.chicks": "Chicks",
    "couples.chick": "Chick",
    "couples.foot_ring": "Foot ring #",
    "couples.hide_chicks": "Hide chicks",
    "couples.show_chicks": "Chicks",
    "couples.reset_confirm_title": "Reset this couple?",
    "couples.reset_confirm_desc": "All data on this row (male mutation, female mutation, 6 egg dates and 6 chicks) will be erased so you can enter a new couple in its place.",
    "birds.title": "Birds Registry",
    "birds.sub": "individual records with parentage · auto-saves on blur",
    "birds.ring": "Chick foot ring",
    "birds.jump_row": "Go to row…",
    "birds.sex": "Sex",
    "birds.male": "Male",
    "birds.female": "Female",
    "birds.mutation": "Chick mutation",
    "birds.father_ring": "Father ring",
    "birds.father_mut": "Father mutation",
    "birds.mother_ring": "Mother ring",
    "birds.mother_mut": "Mother mutation",
    "birds.pedigree": "Pedigree",
    "birds.reset_confirm_title": "Reset this bird?",
    "birds.reset_confirm_desc": "All data on this row (ring, sex, mutation and parentage) will be erased so you can enter a new bird in its place.",
    "text.menu": "Text style",
    "text.bold": "Bold",
    "text.size": "Font size",
    "text.size_sm": "Small",
    "text.size_md": "Medium",
    "text.size_lg": "Large",
    "text.font_color": "Font color",
    "text.cell_bg": "Cell background",
    "text.default": "Default",
    "text.reset": "Reset",
    "text.align": "Text alignment",
    "text.align_left": "Left",
    "text.align_center": "Center",
    "text.align_right": "Right",
    "courses.title": "Supplements & Recovery",
    "courses.sub": "Track nutritional supplements and recovery courses · per-cage and group-wide",
    "courses.tab_supplements": "Nutritional Supplements",
    "courses.tab_recovery": "Birds Recovery Course",
    "courses.section_individual": "Individual (per cage)",
    "courses.section_group": "Group (all cages)",
    "courses.reset_btn": "Reset all",
    "courses.reset_confirm_title": "Reset all rows?",
    "courses.reset_supplements_body": "This will clear ALL individual and group supplement rows for this season. This cannot be undone.",
    "courses.reset_recovery_body": "This will clear ALL individual and group recovery course rows for this season. This cannot be undone.",
    "courses.reset_yes": "Yes, reset",
    "courses.reset_no": "Cancel",
    "courses.reset_success": "All rows cleared",
    "courses.cage_no": "Cage #",
    "courses.jump_cage": "Go to cage…",
    "courses.supplement_name": "Supplement name",
    "courses.medication_name": "Medication name",
    "courses.dose": "Dose / amount",
    "courses.start_date": "Start date",
    "courses.end_date": "End date",
    "courses.remark": "Remarks",
    "courses.remark_placeholder": "Write any notes here…",
    "courses.ends_today": "ends today",
    "courses.ends_in": "ends in",
    "courses.days": "days",
    "courses.ended": "ended",
    "courses.reminders_title": "Course endings",
    "sub.title": "Subscription",
    "sub.choose_plan": "Choose a plan",
    "sub.method": "Payment method",
    "sub.paypal": "PayPal (USD)",
    "sub.benefitpay": "BenefitPay (BHD)",
    "sub.continue_paypal": "Pay with PayPal",
    "sub.continue_benefitpay": "Pay with BenefitPay",
    "sub.benefitpay_instructions": "Open the BenefitPay app on your phone, scan this QR, and pay the amount shown. Then come back here and enter the reference number from the receipt.",
    "sub.benefitpay_amount": "Amount to pay",
    "sub.benefitpay_owner": "Pay to",
    "sub.enter_reference": "BenefitPay reference number",
    "sub.submit_reference": "Submit reference",
    "sub.pending_admin": "Payment submitted. Admin will confirm shortly — you'll get access once verified.",
    "sub.trial_active": "Free trial active",
    "sub.active": "Active",
    "sub.expired": "Subscription expired",
    "sub.expired_message": "Your subscription has expired. Choose a plan below to continue using the schedules.",
    "sub.days_left": "days left",
    "sub.expires_on": "Expires on",
    "sub.renew_now": "Renew now",
    "sub.subscribe": "Subscribe / Renew",
    "sub.thank_you": "Thank you — your subscription is active.",
    "sub.popular": "Most popular",
    "sub.admin_panel": "Subscriptions admin",
    "sub.admin_pending": "Pending confirmations",
    "sub.admin_confirm": "Confirm",
    "sub.admin_extend": "Extend",
    "sub.admin_users": "All users",
    "sub.upload_qr": "Upload BenefitPay QR",
    "sub.qr_uploaded": "QR uploaded",
    "sub.paypal_link": "Apple Pay / Card",
    "sub.link_instructions": "Click below to open the secure PayPal payment page. You can pay with Apple Pay, PayPal, or any debit/credit card. After paying, come back here and enter the PayPal Transaction ID from your receipt.",
    "sub.open_payment": "Open payment page",
    "sub.enter_txn": "PayPal transaction ID",
    "sub.method_col": "Method",
    "courses.reset_row": "Clear line",
    "courses.reset_row_done": "Line cleared",
    "admin.email_title": "Send email to users",
    "admin.email_to": "Recipient",
    "admin.email_all": "All users",
    "admin.email_select_all": "Select all",
    "admin.email_subject": "Subject",
    "admin.email_message": "Message",
    "admin.email_send": "Send email",
    "nav.remarks": "Remarks",
    "nav.reviews": "Feedback",
    "reviews.title": "Feedback",
    "reviews.sub": "Tell us how you feel about the app — what to change or add. Everyone can see the ratings.",
    "reviews.your_rating": "Your rating",
    "reviews.placeholder": "Write your feedback here…",
    "reviews.submit": "Post feedback",
    "reviews.thanks": "Thank you for your feedback!",
    "reviews.pick_stars": "Please choose a star rating first",
    "reviews.all": "All feedback",
    "reviews.none": "No feedback yet — be the first!",
    "reviews.you": "You",
    "reviews.team_badge": "Aviary Studio team",
    "reviews.reply": "Reply",
    "reviews.reply_edit": "Edit reply",
    "reviews.reply_delete": "Delete reply",
    "reviews.reply_placeholder": "Write a public reply…",
    "reviews.reply_save": "Post reply",
    "reviews.reply_cancel": "Cancel",
    "reviews.reply_saved": "Reply posted",
    "reviews.reply_deleted": "Reply deleted",
    "remarks.title": "Remarks",
    "remarks.sub": "Quick shared notes — jot down new egg hatches here, then add them to the schedule later",
    "remarks.placeholder": "Write your notes here… e.g. Cage 12 — 2 eggs hatched today, ring them on Friday",
    "remarks.reset": "Erase all",
    "remarks.reset_confirm": "Erase all remarks? This clears the notes for everyone in this season.",
    "remarks.reset_done": "Remarks erased",
    "remarks.saving": "Saving…",
    "remarks.saved": "Saved",
    "ann.title": "Announcement",
    "ann.sub": "Write an announcement — it will appear as a banner to all users in the app",
    "ann.placeholder": "Write your announcement here…",
    "ann.publish": "Publish to all users",
    "ann.published": "Announcement published",
    "ann.current": "Current announcement",
    "ann.clear": "Remove",
    "ann.cleared": "Announcement removed",
    "ann.none": "No active announcement",
    "ann.msg_en": "Message (English)",
    "ann.msg_ar": "Message (Arabic)",
    "ann.translate_to_en": "Auto-translate to English",
    "ann.translate_to_ar": "Auto-translate to Arabic",
    "ann.placeholder_ar": "اكتب إعلانك هنا…",
    "ann.push_note": "Publishing also sends a push notification to all users who enabled notifications on their devices.",
    "sub.redeem_title": "Have a code?",
    "sub.redeem_ph": "AVY-XXXXXX",
    "sub.redeem_btn": "Redeem",
    "sub.redeem_success": "Code redeemed — 10 days added to your subscription!",
    "sub.redeem_note": "Each code works once. You can redeem 1 code every 10 days.",
    "sub.benefitpay_bahrain_note": "Note: BenefitPay is available for Bahraini bank accounts only.",
    "account.title": "Settings",
    "settings.profile": "User profile",
    "account.name": "Name",
    "settings.phone": "Phone number",
    "settings.email": "Email",
    "settings.save": "Save changes",
    "settings.saved": "Profile updated",
    "settings.security": "Security",
    "settings.current_password": "Current password",
    "settings.new_password": "New password",
    "settings.confirm_password": "Confirm new password",
    "settings.change_password": "Change password",
    "settings.password_changed": "Password changed",
    "settings.password_mismatch": "Passwords do not match",
    "settings.feedback": "Suggestions & Complaints",
    "settings.suggestion": "Suggestion",
    "settings.complaint": "Complaint",
    "settings.suggestion_ph": "Write your suggestion here…",
    "settings.complaint_ph": "Write your complaint here…",
    "settings.send": "Send",
    "settings.feedback_sent": "Sent — thank you!",
    "settings.contact": "Contact us",
    "settings.whatsapp": "Chat on WhatsApp",
    "nav.settings": "Settings",
    "nav.messages": "Messages",
    "messages.title": "Messages",
    "messages.sub": "Send and receive private messages inside the app.",
    "messages.compose": "New message",
    "messages.recipient": "To",
    "messages.recipients": "Recipients",
    "messages.mode_single": "Single user",
    "messages.mode_multiple": "Multiple users",
    "messages.mode_all": "Everyone",
    "messages.all_note": "This message will be sent to all {n} users.",
    "messages.pick_recipient": "Choose a recipient…",
    "messages.body_placeholder": "Write your message here…",
    "messages.body_required": "Please write a message first",
    "messages.send": "Send",
    "messages.sent_ok": "Message sent to {n} user(s)",
    "messages.inbox": "Inbox",
    "messages.sent_tab": "Sent",
    "messages.none_inbox": "No messages yet.",
    "messages.none_sent": "You haven't sent any messages yet.",
    "messages.to": "To",
    "messages.read_badge": "Read",
    "messages.reply": "Reply",
    "messages.delete": "Delete",
    "messages.delete_confirm": "Delete this message?",
    "messages.deleted": "Message deleted",
    "messages.broadcast_badge": "Announcement",
    "admin.deleted_groups": "Deleted groups (recovery)",
    "admin.deleted_empty": "No deleted groups. When a user deletes a group, it appears here for recovery.",
    "admin.deleted_group_col": "Group",
    "admin.deleted_invite_col": "Invite",
    "admin.deleted_data_col": "Data",
    "admin.deleted_by_col": "Deleted by",
    "admin.deleted_when_col": "When",
    "admin.deleted_restore_btn": "Restore",
    "admin.deleted_couples": "{n} couples",
    "admin.deleted_birds": "{n} birds",
    "admin.restore_confirm": "Restore \"{name}\"? It will reappear in the user's groups.",
    "admin.restore_success": "Group restored",
    "auth.forgot_password": "Forgot password?",
    "auth.forgot_sub": "Enter your email and we'll send you a link to reset your password.",
    "auth.forgot_send": "Send reset link",
    "auth.forgot_sent": "If that email exists in our system, a reset link has been sent. Check your inbox (and spam folder).",
    "auth.reset_password": "Reset password",
    "auth.new_password": "New password",
    "auth.confirm_password": "Confirm password",
    "auth.set_new_password": "Set new password",
    "auth.reset_done": "Password reset successfully. Redirecting to login…",
    "auth.password_too_short": "Password must be at least 6 characters.",
    "auth.passwords_dont_match": "Passwords don't match.",
    "auth.admin_reset_btn": "Reset password",
    "auth.admin_reset_title": "Reset user password",
    "auth.admin_reset_done": "Temporary password generated. Copy it now — it won't be shown again.",
    "notif.title": "Notifications",
    "notif.empty": "No activity yet. Changes by other members will appear here.",
    "notif.updated": "updated",
    "notif.new_updates": "new updates",
    "notif.push_on": "On",
    "notif.push_off": "Off",
    "notif.push_enabled": "Background notifications enabled",
    "notif.push_disabled": "Background notifications disabled",
    "notif.push_denied": "Notifications were blocked in your browser settings.",
    "notif.push_failed": "Could not enable notifications.",
    "notif.unsupported": "Background notifications aren't supported in this browser. iOS requires installing the app via Share → Add to Home Screen (iOS 16.4+).",
    "pedigree.title": "Pedigree",
    "pedigree.sub": "Up to 3 generations. Add father/mother rings on the Birds Registry to extend the tree.",
    "pedigree.placeholder": "Bird foot ring",
    "pedigree.show": "Show tree",
    "pedigree.enter": "Enter a foot ring above to view its pedigree.",
    "pedigree.notfound": "No bird found for ring",
    "pedigree.unknown": "Unknown",
    "reminders.title": "Hatch reminders",
    "reminders.days_unit": "days",
    "reminders.attention_one": "egg needs attention",
    "reminders.attention_other": "eggs need attention",
    "reminders.upcoming_one": "egg upcoming",
    "reminders.upcoming_other": "eggs upcoming",
    "reminders.overdue": "overdue",
    "reminders.today": "Today",
    "reminders.in_days": "In",
    "reminders.enable": "Enable alerts",
    "reminders.dismiss": "Dismiss",
    "settings.title": "Season settings",
    "settings.sub_owner": "Rename your season, set its colors and the incubation period used by hatch reminders.",
    "settings.sub_member": "Only the season owner can change these settings.",
    "settings.name": "Season name",
    "settings.incubation": "Incubation period",
    "settings.appearance": "Appearance",
    "settings.bg_color": "Background",
    "settings.accent_color": "Accent / ring color",
    "settings.use_hint": "Pick a different color each season — like ring colors year-to-year.",
    "settings.new_season": "End this season & start a new one",
    "settings.new_season_sub": "Archives the current season (keeps the schedule) and opens a fresh schedule with the same members and colors.",
    "settings.new_season_btn": "Start new season…",
    "settings.new_season_title": "Start a new season",
    "settings.new_season_label": "New season name",
    "settings.new_season_placeholder": "e.g. Season 2027",
    "settings.danger_zone": "Danger zone",
    "settings.delete_group": "Delete this group",
    "settings.delete_sub": "Permanently removes this group's schedules from the app. Admins can restore deleted groups on request.",
    "settings.delete_btn": "Delete group…",
    "settings.delete_confirm_title": "Delete this group?",
    "settings.delete_confirm_body": "This will delete \"{name}\" and all its couples, birds, and chick data. An admin can restore it later, but members will lose access immediately. Continue?",
    "settings.delete_yes": "Yes, delete",
    "settings.delete_no": "No, keep it",
    "members.title": "Members",
    "members.sub_owner": "Manage who has access to this season's schedules.",
    "members.sub_member": "Members can view and edit this season's schedules.",
    "members.owner": "Owner",
    "members.remove": "Remove",
    "members.transfer": "Transfer",
    "members.leave": "Leave",
    "members.invite_more": "Invite more breeders",
    "members.remove_title": "Remove member?",
    "members.transfer_title": "Transfer ownership?",
    "members.leave_title": "Leave this season?",
  },
  ar: {
    "app.brand": "أَفياري ستوديو",
    "app.tagline": "جداول التربية",
    "common.save": "حفظ",
    "common.edit": "تعديل",
    "common.delete": "حذف",
    "common.close": "إغلاق",
    "common.cancel": "إلغاء",
    "common.signin": "تسجيل الدخول",
    "common.signup": "إنشاء حساب",
    "common.email": "البريد الإلكتروني",
    "common.password": "كلمة المرور",
    "common.name": "الاسم",
    "common.loading": "جارٍ التحميل…",
    "common.updated": "آخر تحديث",
    "common.clear": "مسح",
    "common.reset": "مسح الصف",
    "common.confirm": "تأكيد",
    "common.language": "اللغة",
    "common.you": "أنت",
    "common.back": "رجوع",
    "auth.welcome": "مرحبًا بعودتك",
    "auth.signin_sub": "سجّل الدخول لمتابعة إدارة جداول التربية.",
    "auth.signup_title": "إنشاء حساب",
    "auth.signup_sub": "ابدأ بتسجيل أزواج التربية خلال دقائق.",
    "auth.new_to": "جديد في أفياري ستوديو؟",
    "auth.have_account": "لديك حساب بالفعل؟",
    "auth.password_min": "كلمة المرور (٦ أحرف على الأقل)",
    "nav.couples": "الأزواج",
    "nav.logout": "تسجيل الخروج",
    "nav.birds": "سجل الطيور",
    "nav.pedigree": "شجرة النسب",
    "nav.courses": "المكمّلات والعلاج",
    "sync.synced": "متزامن",
    "sync.syncing": "جاري المزامنة…",
    "sync.offline": "غير متصل",
    "group.label": "الموسم",
    "group.switch": "تبديل الموسم",
    "group.invite_code": "رمز الدعوة",
    "group.copy": "نسخ",
    "group.copied": "تم النسخ",
    "group.members": "الأعضاء",
    "group.settings": "إعدادات الموسم",
    "group.new_join": "موسم جديد / انضمام",
    "groups.landing_add": "أضف موسمًا آخر",
    "groups.landing_first": "أنشئ موسم تربية أو انضم إلى واحد",
    "groups.landing_sub": "لكل موسم جداوله الخاصة متزامنة مع جميع الأعضاء. شارك رمز الدعوة مع زملائك.",
    "groups.intro_title": "مرحباً بك في BREEDERS & TRACKING APP",
    "groups.intro_body": "تطبيق للمربين. تابع جميع أزواجك وسجّل جميع فراخك لكل موسم — البيض، تواريخ الفقس، أرقام حجول الفراخ، الطفرات والأنساب — كل شيء يتزامن لحظياً بين الجوال والحاسوب. شارك الموسم مع فريقك برمز دعوة واحد.",
    "groups.intro_pt_1": "مزامنة فورية بين الأجهزة — تعمل دون اتصال أيضاً",
    "groups.intro_pt_2": "من وضع البيض إلى الفقس — تتبع فقس البيض مع تنبيه",
    "groups.intro_pt_3": "ثنائي اللغة EN / AR · طباعة وتصدير CSV",
    "groups.intro_pt_4": "تابع فترة حضانة طيورك واختر نوع الطيور بين الكناري، البادجي، طيور الحب، الكوكتيل، الزيبرا فينش والببغاء",
    "nav.market": "سوق الطيور",
    "market.title": "سوق الطيور",
    "market.sub": "بِع واشترِ الطيور مع المربّين — افتح العرض لترى الصور والفيديو والوصف ووسيلة التواصل",
    "market.selling": "طيور للبيع",
    "market.selling_sub": "طيور يعرضها المربّون للبيع",
    "market.buying": "طيور مطلوبة للشراء",
    "market.buying_sub": "طيور يبحث المربّون عن شرائها",
    "market.add_bird": "إضافة طير",
    "market.edit_offer": "تعديل العرض",
    "market.all_species": "كل الأنواع",
    "market.species": "النوع",
    "market.species_canary": "كناري",
    "market.species_budgie": "بادجي",
    "market.species_lovebird": "طيور الحب",
    "market.species_cockatiel": "كوكتيل",
    "market.species_zebra_finch": "زيبرا فينش",
    "market.species_parrot": "ببغاء",
    "market.species_other": "أخرى",
    "market.offer_title": "العنوان",
    "market.description": "الوصف ووسيلة التواصل",
    "market.description_hint": "اكتب وصف الطير: العمر، الجنس، الحجل، اللون، السعر… وأضف رقم التواصل ليتمكن الآخرون من الوصول إليك.",
    "market.media": "الصور / الفيديو",
    "market.media_hint": "حتى {n} صور ({i} م.ب لكل صورة) وفيديو واحد ({v} م.ب كحد أقصى)",
    "market.browse": "استعراض الملفات",
    "market.upload": "رفع",
    "market.uploading": "جارٍ الرفع…",
    "market.published": "تم نشر العرض",
    "market.saved": "تم حفظ العرض",
    "market.deleted": "تم حذف العرض",
    "market.reopened": "تمت إعادة فتح العرض",
    "market.empty": "لا توجد عروض بعد — كن أول من يضيف عرضًا.",
    "market.not_found": "هذا العرض لم يعد موجودًا.",
    "market.files": "ملف",
    "market.replies": "رد من المشرف",
    "market.copy": "نسخ",
    "market.sold": "تم البيع",
    "market.bought": "تم الشراء",
    "market.mark_sold": "تحديد كـ تم البيع",
    "market.mark_bought": "تحديد كـ تم الشراء",
    "market.mark_open": "إعادة فتح العرض",
    "market.delete_title": "حذف هذا العرض؟",
    "market.delete_body": "سيتم إزالة العرض وصوره/فيديوه من السوق.",
    "market.reply_placeholder": "رد المشرف (مثال: يرجى تحديد العرض كـ تم البيع إذا بيع الطير)",
    "market.err_max_images": "الحد الأقصى {n} صور لكل عرض",
    "market.err_image_size": "يجب أن تكون كل صورة أقل من {n} م.ب",
    "market.err_one_video": "فيديو واحد فقط لكل عرض",
    "market.err_video_size": "يجب أن يكون الفيديو أقل من {n} م.ب",
    "market.err_type": "يُسمح بالصور والفيديو فقط",
    "market.err_upload": "فشل الرفع، حاول مرة أخرى",
    "market.search_placeholder": "ابحث في العروض بالعنوان أو الوصف أو اسم المربّي…",
    "market.no_results": "لا توجد عروض تطابق بحثك أو الفلتر.",
    "market.follow": "نبّهني عند إضافة {s}",
    "market.unfollow": "إيقاف تنبيهات {s}",
    "market.followed": "ستصلك إشعارات عند ظهور عرض جديد",
    "market.unfollowed": "تم إيقاف الإشعارات",
    "market.mine": "عروضي",
    "market.mine_sub": "كل عروض البيع والشراء الخاصة بك في مكان واحد — حدّدها كـ تم البيع/الشراء أو عدّلها أو احذفها",
    "market.mine_empty": "لا توجد عروض هنا.",
    "market.status_open": "مفتوح",
    "market.age_days": "منذ {n} يوم",
    "market.stale_tag": "أقدم من ٣٠ يومًا",
    "market.filter_all": "الكل",
    "market.filter_pending": "معلّق",
    "market.filter_done": "تم البيع / الشراء",
    "market.filter_sold": "تم البيع",
    "market.filter_bought": "تم الشراء",
    "market.sort_new": "الأحدث",
    "market.sort_old": "الأقدم",
    "domain.title": "انتقلنا إلى breedtrackers.com",
    "domain.body": "يرجى استخدام العنوان الجديد من الآن — نفس الحساب ونفس البيانات. أضفه إلى الشاشة الرئيسية للوصول السريع.",
    "domain.open": "افتح breedtrackers.com",
    "common.refresh": "تحديث",
    "stale.title": "العروض القديمة في السوق",
    "stale.sub": "{n} عرض معلّق أقدم من ٣٠ يومًا · {o} عرض مفتوح إجمالًا",
    "stale.sub_loading": "جارٍ التحميل…",
    "stale.empty": "لا توجد عروض معلّقة أقدم من ٣٠ يومًا.",
    "stale.owner": "المالك",
    "stale.age": "العمر",
    "stale.last_reminded": "آخر تذكير",
    "stale.never": "لم يُرسل",
    "stale.remind": "تذكير المالك",
    "stale.run_now": "إرسال التذكيرات المستحقة",
    "stale.ran": "تم إرسال {n} تذكير",
    "stale.done": "تم",
    "stale.reminded": "تم إرسال التذكير للمالك (رسالة، إشعار وبريد)",
    "stale.failed": "فشل الإجراء",
    "groups.intro_pt_5": "احصل على اشتراك مجاني لمدة ٧ أيام عند إنشاء حسابك",
    "groups.intro_pt_7": "إذا أعجبك التطبيق يمكنك الاشتراك — والاشتراكات في متناول الجميع",
    "groups.intro_pt_6": "توجّه إلى صفحة الاقتراحات والشكاوى في الإعدادات — نهتم باقتراحاتك ونسعى لحل مشكلاتك",
    "groups.intro_pt_8": "إذا حذفت موسمًا أو الحساب عن طريق الخطأ تواصل معي وأستطيع استعادته لك",
    "groups.intro_pt_9": "هل تحتفظ بملف موسمك في هاتفك أو جهاز الكمبيوتر؟ تخشى أن يتعطّل هاتفك أو يتلف الملف وتفقد كل بياناتك؟ جرّب تطبيق Breeders Tracking ولن تفقد أي بيانات.",
    "groups.intro_pt_10": "مع تطبيق Breeders Tracking كل ما يحتاجه المربّي في مكان واحد: تسجيل الأزواج، تسجيل الفراخ بالحجول، كورسات المكملات والاستشفاء، وحتى شجرة نسب الطيور. جرّبه ولن تندم.",
    "share.button": "مشاركة",
    "share.title": "شارك هذه البطاقة",
    "share.cta": "جرّبه مجانًا لمدة 7 أيام",
    "share.scan": "امسح الرمز أو افتح الرابط للبدء",
    "share.msg": "تطبيق Breeders Tracking — احفظ جميع مواسم تربيتك في مكان واحد وبأمان. جرّبه مجانًا:",
    "share.share": "مشاركة",
    "share.download": "تحميل الصورة",
    "share.copy_link": "نسخ الرابط",
    "share.copied": "تم نسخ الرابط",
    "share.downloaded": "تم تحميل الصورة ونسخ الرابط — الصقهما في منشورك",
    "share.failed": "تعذّر إنشاء الصورة، حاول مرة أخرى",
    "share.desktop_hint": "تم نسخ الرسالة — الصقها في منشورك",
    "share.desktop_hint_img": "تم تحميل الصورة ونسخ النص — أضفهما إلى منشورك",
    "bcast.title": "إرسال بريد لجميع المستخدمين",
    "bcast.sub": "أرسل إعلانًا ثنائي اللغة لكل المستخدمين المسجّلين ({n} مستلم). معبّأ مسبقًا بإشعار العنوان الجديد.",
    "bcast.subject": "الموضوع",
    "bcast.test_placeholder": "أرسل نسخة تجريبية إلى هذا البريد أولًا",
    "bcast.send_test": "إرسال تجريبي",
    "bcast.send_all": "إرسال للجميع ({n})",
    "bcast.test_sent": "تم إرسال البريد التجريبي",
    "bcast.started": "بدأ الإرسال — التقدّم معروض بالأسفل",
    "bcast.confirm_title": "إرسال للجميع؟",
    "bcast.confirm_body": "سيتم إرسال البريد إلى جميع المستخدمين المسجّلين ({n}). لا يمكن التراجع.",
    "bcast.confirm_yes": "نعم، أرسل للجميع",
    "bcast.done": "تم",
    "bcast.running": "جارٍ الإرسال",
    "bcast.queued": "في الانتظار",
    "bcast.interrupted": "توقّف",
    "bcast.failed": "فشل",
    "bcast.retry": "إعادة إرسال الفاشلة",
    "bcast.retry_label": "إعادة",
    "bcast.last_error": "آخر خطأ",
    "bcast.health_ok": "خدمة البريد جاهزة — المفتاح صالح والنطاق موثّق",
    "bcast.health_bad": "مشكلة في خدمة البريد",
    "elog.title": "سجل تسليم البريد",
    "elog.sub": "كل بريد أرسله التطبيق — تلقائي أو يدوي — مع حالة التسليم أو الفشل",
    "elog.total_30d": "مُرسل (30 يومًا)",
    "elog.delivered": "تم التسليم",
    "elog.failed": "فشل",
    "elog.all": "الكل",
    "elog.empty": "لا توجد رسائل مسجّلة بعد.",
    "elog.col_time": "الوقت",
    "elog.col_kind": "النوع",
    "elog.col_to": "إلى",
    "elog.col_subject": "الموضوع",
    "elog.col_status": "الحالة",
    "elog.ok": "تم التسليم",
    "elog.fail": "فشل",
    "elog.kind_warning": "تنبيه تجديد",
    "elog.kind_gift_reminder": "تذكير كود الهدية",
    "elog.kind_broadcast": "إعلان",
    "elog.kind_broadcast_test": "تجربة إعلان",
    "elog.kind_admin_notice": "تنبيه للمشرف",
    "elog.kind_admin_message": "بريد من المشرف",
    "elog.kind_password_reset": "استعادة كلمة المرور",
    "elog.kind_other": "أخرى",
    "lb.title": "لوحة صدارة الدعوات",
    "lb.sub": "أكثر المربّين دعوةً والأيام المجانية الممنوحة",
    "lb.inviters": "مربّون دعوا",
    "lb.signups": "انضموا عبر الروابط",
    "lb.subscribed": "اشتركوا منهم",
    "lb.days_given": "أيام مجانية مُنحت",
    "lb.empty": "لا توجد دعوات بعد.",
    "lb.breeder": "المربّي",
    "lb.col_signups": "دعا",
    "lb.col_subscribed": "اشتركوا",
    "lb.col_days": "أيام ربحها",
    "lb.leader_title": "المتصدّر هذا الشهر",
    "lb.no_leader": "لا توجد دعوات هذا الشهر بعد",
    "lb.bonus_note": "في أول كل شهر يحصل أكثر المربّين دعوةً على شارة و{d} أيام مجانية إضافية.",
    "badge.top_inviter": "أكثر داعٍ",
    "badge.top_inviter_hint": "أكثر مربٍّ دعوةً في الشهر — شكرًا لك على تنمية المجتمع!",
    "badge.leading": "متصدّر هذا الشهر",
    "ref.monthly_bonus": "كما يحصل أكثر المربّين دعوةً كل شهر على شارة و10 أيام مجانية إضافية.",
    "groups.intro_pt_11": "لكل مربٍّ رابط دعوة خاص به: كل 5 مربّين جدد يسجّلون عبر رابطك تحصل على 3 أيام مجانية، وإذا اشترك 3 منهم تحصل على 5 أيام مجانية إضافية. كما يحصل أكثر المربّين دعوةً كل شهر على شارة و10 أيام مجانية إضافية.",
    "groups.intro_pt_12": "مع تطبيق Breeders Tracking يمكنك الآن عرض طيورك للبيع أو طلب شراء طيور في سوق الطيور.",
    "groups.intro_pt_13": "الرابط الرسمي للتطبيق:",
    "ref.title": "ادعُ واربح",
    "ref.sub": "شارك رابطك الخاص مع أصدقائك المربّين واربح أيامًا مجانية",
    "ref.rules": "كل {n} مربّين جدد يسجّلون عبر رابطك تحصل على {d1} أيام مجانية. وإذا اشترك {k} من هؤلاء الـ{n} تحصل على {d2} أيام مجانية إضافية.",
    "ref.share_msg": "انضم إليّ في تطبيق Breeders Tracking — احفظ جميع مواسم تربيتك في مكان واحد وبأمان. سجّل عبر رابطي وجرّبه مجانًا 7 أيام:",
    "ref.stat_signups": "سجّلوا عبر رابطك",
    "ref.stat_subscribed": "اشتركوا منهم",
    "ref.stat_next": "متبقٍّ للمكافأة التالية",
    "ref.stat_days": "أيام مجانية ربحتها",
    "ref.list_title": "المدعوّون",
    "ref.empty": "لم يسجّل أحد عبر رابطك بعد — شاركه!",
    "ref.subscribed": "مشترك",
    "ref.joined": "انضم",
    "ref.reward_signup": "+{d} أيام — 5 مربّين جدد (المجموعة {b})",
    "ref.reward_sub": "+{d} أيام — اشترك 3 من المجموعة {b}",
    "ref.invited_by": "تمت دعوتك من {name} — أهلًا بك!",
    "ref.earn_link": "ادعُ أصدقاءك واربح أيامًا مجانية",
    "groups.featured_reviews_title": "ماذا يقول مستخدمونا",
    "stats.eggs": "البيض",
    "stats.hatched": "الفقس",
    "stats.rate": "نسبة الفقس",
    "stats.pairs": "أزواج نشطة",
    "activity.title": "نشاط المستخدمين",
    "activity.sub": "من متصل الآن، ومتى سجلوا الدخول، وماذا فعلوا",
    "activity.online": "متصل",
    "activity.offline": "غير متصل",
    "activity.last_login": "آخر تسجيل دخول",
    "activity.duration": "مدة الجلسة",
    "activity.actions": "آخر الإجراءات",
    "activity.none": "لا توجد إجراءات مسجلة بعد.",
    "activity.refresh": "تحديث",
    "activity.kind_login": "سجّل الدخول",
    "activity.kind_couple": "حدّث زوجًا",
    "activity.kind_bird": "حدّث طائرًا",
    "drip.title": "العدّ التنازلي للتجديد",
    "drip.sub": "الحسابات المنتهية، ومرحلة التنبيه، والأيام المتبقية قبل الحذف التلقائي",
    "drip.run": "شغّل الفحص الآن",
    "drip.ran": "تم الفحص: أُرسل {sent} بريد، حُذف {deleted} حساب",
    "drip.empty": "لا توجد حسابات منتهية حاليًا.",
    "drip.expired_for": "انتهى منذ {d} يوم",
    "drip.stage": "المرحلة",
    "drip.stage_none": "لم يُنبَّه بعد",
    "drip.stage_n": "تنبيه {n} من 4",
    "drip.next_in": "البريد التالي بعد {d} يوم",
    "drip.delete_in": "الحذف بعد {d} يوم",
    "drip.delete_due": "مستحق للحذف",
    "drip.last_sent": "آخر بريد",
    "drip.code": "كود الهدية",
    "drip.code_used": "مستخدم",
    "drip.code_unused": "غير مستخدم",
    "drip.reminded": "تم إرسال التذكير",
    "drip.stats_title": "هذا الشهر",
    "drip.stat_countdown": "في العدّ التنازلي",
    "drip.stat_warnings": "تنبيهات مُرسلة",
    "drip.stat_reminders": "تذكيرات الكود",
    "drip.stat_deleted": "حُذفت تلقائيًا",
    "drip.stat_comebacks": "عادوا",
    "drip.stat_renewed": "جدّدوا",
    "comeback.title": "العائدون",
    "comeback.sub": "المستخدمون الذين عادوا بعد تنبيه التجديد، وهل جدّدوا أم لا",
    "comeback.empty": "لم يعد أحد بعد.",
    "comeback.type_restored": "تمت استعادة الحساب",
    "comeback.type_login_after_warning": "سجّل الدخول بعد التنبيه",
    "comeback.type_renewed": "جدّد بعد التنبيه",
    "comeback.after_stage": "بعد التنبيه {n}",
    "comeback.returned": "عاد",
    "comeback.renewed": "جدّد",
    "comeback.not_renewed": "لم يجدّد بعد",
    "comeback.gone": "حُذف مجددًا",
    "welcome_back.title": "مرحبًا بعودتك، {name}!",
    "welcome_back.body": "تمت استعادة حسابك وجميع مواسمك. جدّد اشتراكك لتواصل من حيث توقفت.",
    "welcome_back.renew": "جدّد الآن",
    "drip.plan": "الخطة",
    "drip.plan_none": "بدون اشتراك",
    "bulk.add": "إضافة دفعة",
    "bulk.delete": "حذف",
    "bulk.delete_confirm": "هل تريد حذف الأسطر المحددة؟ سيتم حذف بياناتها.",
    "bulk.added": "تمت إضافة الأسطر",
    "bulk.deleted": "تم حذف الأسطر",
    "sub.badge_label": "الاشتراك",
    "sub.teaser_title": "تجربة مجانية لمدة 7 أيام",
    "sub.teaser_body": "يبدأ حسابك بفترة تجربة مجانية لمدة 7 أيام. بعدها اختر الخطة المناسبة لمشروعك. ادفع عبر PayPal أو BenefitPay (البحرين).",
    "sub.plan_1m_label": "شهر واحد",
    "sub.plan_3m_label": "٣ أشهر",
    "sub.plan_6m_label": "٦ أشهر",
    "sub.plan_1y_label": "سنة كاملة",
    "sub.plan_1y_save": "الأفضل قيمة",
    "sub.teaser_view": "عرض خطط الاشتراك",
    "footer.copyright": "© {year} Aviary Studio · جميع الحقوق محفوظة.",
    "footer.tagline": "صُمم من مربٍّ، لكل المربين.",
    "auth.social_divider": "أو سجل دخولك من خلال",
    "auth.social_coming_soon": "تسجيل الدخول عبر {provider} سيتوفر قريباً — الرجاء استخدام البريد الإلكتروني أو جوجل في الوقت الحالي.",
    "auth.google_button": "المتابعة عبر جوجل",
    "auth.delete_account": "حذف حسابي",
    "auth.delete_account_btn": "حذف الحساب",
    "auth.delete_account_title": "حذف حسابك نهائياً؟",
    "auth.delete_account_body": "سيؤدي هذا إلى حذف ملفك الشخصي والمواسم التي تملكها والاشتراكات والصور والإشعارات. يمكن للمشرف استعادة المواسم خلال 30 يوماً. اكتب DELETE أدناه للتأكيد.",
    "auth.delete_account_confirm_label": "اكتب DELETE للتأكيد",
    "auth.delete_account_yes": "نعم، احذف نهائياً",
    "auth.delete_account_no": "إلغاء",
    "auth.delete_account_success": "تم حذف الحساب. مع السلامة 👋",
    "admin.delete_user_btn": "حذف",
    "admin.delete_user_title": "حذف المستخدم {email}؟",
    "admin.delete_user_body": "سيتم حذف المستخدم نهائياً مع جميع مواسمه (تُحفظ نسخة احتياطية للاستعادة) واشتراكاته وصوره وإشعاراته. سيتم تسجيل خروجه من كل الأجهزة. متابعة؟",
    "admin.delete_user_yes": "نعم، احذف",
    "admin.delete_user_no": "إلغاء",
    "admin.delete_user_success": "تم حذف المستخدم {email}",
    "admin.deleted_users": "المستخدمون المحذوفون (استعادة)",
    "admin.deleted_users_empty": "لا يوجد مستخدمون محذوفون. عند حذف أي حساب، سيظهر هنا لاستعادته خلال 30 يوماً.",
    "admin.deleted_user_email_col": "البريد الإلكتروني",
    "admin.deleted_user_role_col": "الدور",
    "admin.deleted_user_pwd_col": "كلمة المرور محفوظة",
    "admin.restore_user_btn": "استعادة",
    "admin.restore_user_confirm": "هل تريد استعادة {email}؟ ستعمل كلمة مروره الأصلية كما هي (أو جوجل إذا سجل عبرها). يجب استعادة المواسم المملوكة من قسم المواسم المحذوفة بشكل منفصل.",
    "admin.restore_user_success": "تمت استعادة {email} — كلمة المرور الأصلية لا تزال تعمل",
    "sub.try_benefitpay": "جرب BenefitPay بدلاً من ذلك",
    "groups.create": "إنشاء",
    "groups.join": "انضمام برمز",
    "groups.name_label": "اسم الموسم",
    "groups.name_placeholder": "مثلاً: موسم 2026، كناري A1",
    "groups.create_btn": "إنشاء موسم",
    "groups.join_btn": "الانضمام",
    "groups.code_label": "رمز الدعوة",
    "groups.your_groups": "مواسمك",
    "groups.open": "فتح",
    "couples.title": "أزواج التربية",
    "couples.sub": "٦ تواريخ بيض · ٦ خانات أفراخ · حفظ تلقائي عند الخروج من الحقل",
    "couples.male": "طفرة الذكر",
    "couples.jump_pair": "اذهب إلى الزوج…",
    "couples.female": "طفرة الأنثى",
    "couples.male_placeholder": "♂ طفرة الذكر",
    "couples.female_placeholder": "♀ طفرة الأنثى",
    "couples.egg": "بيضة",
    "couples.egg_dates": "تواريخ البيض",
    "couples.chicks": "الأفراخ",
    "couples.chick": "فرخ",
    "couples.foot_ring": "رقم الحجل",
    "couples.hide_chicks": "إخفاء الأفراخ",
    "couples.show_chicks": "الأفراخ",
    "couples.reset_confirm_title": "إعادة تعيين هذا الزوج؟",
    "couples.reset_confirm_desc": "ستُمسح كل بيانات هذا الصف (طفرة الذكر، طفرة الأنثى، تواريخ البيض الستة، والأفراخ الستة) لتتمكن من إدخال زوج جديد مكانه.",
    "birds.title": "سجل الطيور",
    "birds.sub": "بيانات الطائر مع نسبه · حفظ تلقائي عند الخروج من الحقل",
    "birds.ring": "حجل الفرخ",
    "birds.jump_row": "اذهب إلى الصف…",
    "birds.sex": "الجنس",
    "birds.male": "ذكر",
    "birds.female": "أنثى",
    "birds.mutation": "طفرة الفرخ",
    "birds.father_ring": "حجل الأب",
    "birds.father_mut": "طفرة الأب",
    "birds.mother_ring": "حجل الأم",
    "birds.mother_mut": "طفرة الأم",
    "birds.pedigree": "شجرة النسب",
    "birds.reset_confirm_title": "إعادة تعيين هذا الطائر؟",
    "birds.reset_confirm_desc": "ستُمسح كل بيانات هذا الصف (الحجل، الجنس، الطفرة والنسب) لتتمكن من إدخال طائر جديد مكانه.",
    "text.menu": "تنسيق النص",
    "text.bold": "عريض",
    "text.size": "حجم الخط",
    "text.size_sm": "صغير",
    "text.size_md": "متوسط",
    "text.size_lg": "كبير",
    "text.font_color": "لون الخط",
    "text.cell_bg": "خلفية الخلية",
    "text.default": "افتراضي",
    "text.reset": "إعادة تعيين",
    "text.align": "محاذاة النص",
    "text.align_left": "يسار",
    "text.align_center": "وسط",
    "text.align_right": "يمين",
    "courses.title": "المكمّلات والعلاج",
    "courses.sub": "متابعة المكمّلات الغذائية وكورسات التعافي · لكل قفص أو لكل الأقفاص",
    "courses.tab_supplements": "المكمّلات الغذائية",
    "courses.tab_recovery": "كورس تعافي الطيور",
    "courses.section_individual": "فردي (لكل قفص)",
    "courses.section_group": "جماعي (لكل الأقفاص)",
    "courses.reset_btn": "إعادة تعيين الكل",
    "courses.reset_confirm_title": "إعادة تعيين جميع الصفوف؟",
    "courses.reset_supplements_body": "سيؤدي هذا إلى مسح كل صفوف المكملات الفردية والجماعية لهذا الموسم. لا يمكن التراجع.",
    "courses.reset_recovery_body": "سيؤدي هذا إلى مسح كل صفوف كورس التعافي الفردية والجماعية لهذا الموسم. لا يمكن التراجع.",
    "courses.reset_yes": "نعم، أعد التعيين",
    "courses.reset_no": "إلغاء",
    "courses.reset_success": "تم مسح كل الصفوف",
    "courses.cage_no": "رقم القفص",
    "courses.jump_cage": "اذهب إلى القفص…",
    "courses.supplement_name": "اسم المكمّل",
    "courses.medication_name": "اسم الدواء",
    "courses.dose": "الجرعة / الكمية",
    "courses.start_date": "تاريخ البدء",
    "courses.end_date": "تاريخ الانتهاء",
    "courses.remark": "ملاحظات",
    "courses.remark_placeholder": "اكتب أي ملاحظات هنا…",
    "courses.ends_today": "ينتهي اليوم",
    "courses.ends_in": "ينتهي خلال",
    "courses.days": "أيام",
    "courses.ended": "انتهى",
    "courses.reminders_title": "نهايات الكورسات",
    "sub.title": "الاشتراك",
    "sub.choose_plan": "اختر باقة",
    "sub.method": "طريقة الدفع",
    "sub.paypal": "PayPal (دولار)",
    "sub.benefitpay": "BenefitPay (دينار بحريني)",
    "sub.continue_paypal": "ادفع عبر PayPal",
    "sub.continue_benefitpay": "ادفع عبر BenefitPay",
    "sub.benefitpay_instructions": "افتح تطبيق BenefitPay وامسح هذا الباركود وادفع المبلغ الموضح. ثم ارجع هنا وأدخل رقم المرجع من الإيصال.",
    "sub.benefitpay_amount": "المبلغ المطلوب",
    "sub.benefitpay_owner": "ادفع إلى",
    "sub.enter_reference": "رقم مرجع BenefitPay",
    "sub.submit_reference": "إرسال المرجع",
    "sub.pending_admin": "تم استلام طلبك. سيقوم المسؤول بالتأكيد قريبًا — وستحصل على الوصول فور التحقق.",
    "sub.trial_active": "تجربة مجانية مفعّلة",
    "sub.active": "مفعّل",
    "sub.expired": "انتهى الاشتراك",
    "sub.expired_message": "انتهى اشتراكك. اختر باقة من الأسفل لمتابعة استخدام الجداول.",
    "sub.days_left": "يوم متبقي",
    "sub.expires_on": "ينتهي في",
    "sub.renew_now": "جدّد الآن",
    "sub.subscribe": "اشترك / جدّد",
    "sub.thank_you": "شكرًا لك — اشتراكك مفعّل.",
    "sub.popular": "الأكثر طلبًا",
    "sub.admin_panel": "إدارة الاشتراكات",
    "sub.admin_pending": "بانتظار التأكيد",
    "sub.admin_confirm": "تأكيد",
    "sub.admin_extend": "تمديد",
    "sub.admin_users": "كل المستخدمين",
    "sub.upload_qr": "رفع QR الخاص بـ BenefitPay",
    "sub.qr_uploaded": "تم رفع QR",
    "sub.paypal_link": "Apple Pay / بطاقة",
    "sub.link_instructions": "اضغط بالأسفل لفتح صفحة الدفع الآمنة من PayPal. يمكنك الدفع عبر Apple Pay أو PayPal أو أي بطاقة سحب/ائتمان. بعد الدفع، ارجع هنا وأدخل رقم معاملة PayPal من الإيصال.",
    "sub.open_payment": "فتح صفحة الدفع",
    "sub.enter_txn": "رقم معاملة PayPal",
    "sub.method_col": "الطريقة",
    "courses.reset_row": "مسح السطر",
    "courses.reset_row_done": "تم مسح السطر",
    "admin.email_title": "إرسال بريد إلكتروني للمستخدمين",
    "admin.email_to": "المستلم",
    "admin.email_all": "جميع المستخدمين",
    "admin.email_select_all": "تحديد الكل",
    "admin.email_subject": "الموضوع",
    "admin.email_message": "الرسالة",
    "admin.email_send": "إرسال البريد",
    "nav.remarks": "الملاحظات",
    "nav.reviews": "تقييم",
    "reviews.title": "تقييم",
    "reviews.sub": "أخبرنا برأيك في التطبيق — ما الذي نغيّره أو نضيفه. الجميع يمكنهم رؤية التقييمات.",
    "reviews.your_rating": "تقييمك",
    "reviews.placeholder": "اكتب رأيك هنا…",
    "reviews.submit": "نشر التقييم",
    "reviews.thanks": "شكراً على تقييمك!",
    "reviews.pick_stars": "الرجاء اختيار عدد النجوم أولاً",
    "reviews.all": "جميع التقييمات",
    "reviews.none": "لا توجد تقييمات بعد — كن أول من يقيّم!",
    "reviews.you": "أنت",
    "reviews.team_badge": "فريق Aviary Studio",
    "reviews.reply": "رد",
    "reviews.reply_edit": "تعديل الرد",
    "reviews.reply_delete": "حذف الرد",
    "reviews.reply_placeholder": "اكتب ردًا عامًا…",
    "reviews.reply_save": "نشر الرد",
    "reviews.reply_cancel": "إلغاء",
    "reviews.reply_saved": "تم نشر الرد",
    "reviews.reply_deleted": "تم حذف الرد",
    "remarks.title": "الملاحظات",
    "remarks.sub": "ملاحظات سريعة مشتركة — دوّن فقس البيض الجديد هنا ثم أضفه إلى الجدول لاحقاً",
    "remarks.placeholder": "اكتب ملاحظاتك هنا… مثال: القفص ١٢ — فقست بيضتان اليوم، التحجيل يوم الجمعة",
    "remarks.reset": "مسح الكل",
    "remarks.reset_confirm": "مسح جميع الملاحظات؟ سيتم حذف الملاحظات لجميع أعضاء هذا الموسم.",
    "remarks.reset_done": "تم مسح الملاحظات",
    "remarks.saving": "جارٍ الحفظ…",
    "remarks.saved": "تم الحفظ",
    "ann.title": "الإعلانات",
    "ann.sub": "اكتب إعلاناً — سيظهر كشريط لجميع المستخدمين في التطبيق",
    "ann.placeholder": "اكتب إعلانك هنا…",
    "ann.publish": "نشر لجميع المستخدمين",
    "ann.published": "تم نشر الإعلان",
    "ann.current": "الإعلان الحالي",
    "ann.clear": "إزالة",
    "ann.cleared": "تمت إزالة الإعلان",
    "ann.none": "لا يوجد إعلان حالي",
    "ann.msg_en": "الرسالة (بالإنجليزية)",
    "ann.msg_ar": "الرسالة (بالعربية)",
    "ann.translate_to_en": "ترجمة تلقائية إلى الإنجليزية",
    "ann.translate_to_ar": "ترجمة تلقائية إلى العربية",
    "ann.placeholder_ar": "اكتب إعلانك هنا…",
    "ann.push_note": "عند النشر سيتم أيضاً إرسال إشعار لجميع المستخدمين الذين فعّلوا الإشعارات على أجهزتهم.",
    "sub.redeem_title": "لديك كود؟",
    "sub.redeem_ph": "AVY-XXXXXX",
    "sub.redeem_btn": "استخدام الكود",
    "sub.redeem_success": "تم استخدام الكود — أُضيفت ١٠ أيام إلى اشتراكك!",
    "sub.redeem_note": "كل كود يعمل مرة واحدة فقط. يمكنك استخدام كود واحد كل ١٠ أيام.",
    "sub.benefitpay_bahrain_note": "ملاحظة: خدمة BenefitPay متاحة لأصحاب الحسابات البنكية البحرينية فقط.",
    "account.title": "الإعدادات",
    "settings.profile": "الملف الشخصي",
    "account.name": "الاسم",
    "settings.phone": "رقم الهاتف",
    "settings.email": "البريد الإلكتروني",
    "settings.save": "حفظ التغييرات",
    "settings.saved": "تم تحديث الملف الشخصي",
    "settings.security": "الأمان",
    "settings.current_password": "كلمة المرور الحالية",
    "settings.new_password": "كلمة المرور الجديدة",
    "settings.confirm_password": "تأكيد كلمة المرور الجديدة",
    "settings.change_password": "تغيير كلمة المرور",
    "settings.password_changed": "تم تغيير كلمة المرور",
    "settings.password_mismatch": "كلمتا المرور غير متطابقتين",
    "settings.feedback": "الاقتراحات والشكاوى",
    "settings.suggestion": "اقتراح",
    "settings.complaint": "شكوى",
    "settings.suggestion_ph": "اكتب اقتراحك هنا…",
    "settings.complaint_ph": "اكتب شكواك هنا…",
    "settings.send": "إرسال",
    "settings.feedback_sent": "تم الإرسال — شكراً لك!",
    "settings.contact": "تواصل معنا",
    "settings.whatsapp": "الدردشة عبر واتساب",
    "nav.settings": "الإعدادات",
    "nav.messages": "الرسائل",
    "messages.title": "الرسائل",
    "messages.sub": "أرسل واستقبل رسائل خاصة داخل التطبيق.",
    "messages.compose": "رسالة جديدة",
    "messages.recipient": "إلى",
    "messages.recipients": "المستلمون",
    "messages.mode_single": "مستخدم واحد",
    "messages.mode_multiple": "عدة مستخدمين",
    "messages.mode_all": "الجميع",
    "messages.all_note": "سيتم إرسال هذه الرسالة إلى جميع المستخدمين ({n}).",
    "messages.pick_recipient": "اختر مستلمًا…",
    "messages.body_placeholder": "اكتب رسالتك هنا…",
    "messages.body_required": "الرجاء كتابة رسالة أولاً",
    "messages.send": "إرسال",
    "messages.sent_ok": "تم إرسال الرسالة إلى {n} مستخدم",
    "messages.inbox": "الوارد",
    "messages.sent_tab": "المرسلة",
    "messages.none_inbox": "لا توجد رسائل بعد.",
    "messages.none_sent": "لم ترسل أي رسائل بعد.",
    "messages.to": "إلى",
    "messages.read_badge": "مقروءة",
    "messages.reply": "رد",
    "messages.delete": "حذف",
    "messages.delete_confirm": "هل تريد حذف هذه الرسالة؟",
    "messages.deleted": "تم حذف الرسالة",
    "messages.broadcast_badge": "إعلان",
    "admin.deleted_groups": "المواسم المحذوفة (استعادة)",
    "admin.deleted_empty": "لا توجد مواسم محذوفة. عند حذف أي مستخدم لموسم، سيظهر هنا لاستعادته.",
    "admin.deleted_group_col": "الموسم",
    "admin.deleted_invite_col": "كود الدعوة",
    "admin.deleted_data_col": "البيانات",
    "admin.deleted_by_col": "حُذف بواسطة",
    "admin.deleted_when_col": "وقت الحذف",
    "admin.deleted_restore_btn": "استعادة",
    "admin.deleted_couples": "{n} زوج",
    "admin.deleted_birds": "{n} طائر",
    "admin.restore_confirm": "هل تريد استعادة \"{name}\"؟ سيعود إلى قائمة مواسم المستخدم.",
    "admin.restore_success": "تمت الاستعادة",
    "auth.forgot_password": "نسيت كلمة المرور؟",
    "auth.forgot_sub": "أدخل بريدك وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
    "auth.forgot_send": "إرسال رابط الاستعادة",
    "auth.forgot_sent": "إذا كان البريد موجودًا، فقد أُرسل رابط الاستعادة. تحقّق من البريد الوارد والبريد المهمل.",
    "auth.reset_password": "إعادة تعيين كلمة المرور",
    "auth.new_password": "كلمة المرور الجديدة",
    "auth.confirm_password": "تأكيد كلمة المرور",
    "auth.set_new_password": "تعيين كلمة المرور",
    "auth.reset_done": "تم تغيير كلمة المرور بنجاح. جارٍ التحويل لتسجيل الدخول…",
    "auth.password_too_short": "يجب ألا تقل كلمة المرور عن 6 أحرف.",
    "auth.passwords_dont_match": "كلمتا المرور غير متطابقتين.",
    "auth.admin_reset_btn": "إعادة تعيين كلمة المرور",
    "auth.admin_reset_title": "إعادة تعيين كلمة مرور المستخدم",
    "auth.admin_reset_done": "تم إنشاء كلمة مرور مؤقتة. انسخها الآن — لن تُعرض مرة أخرى.",
    "notif.title": "الإشعارات",
    "notif.empty": "لا توجد تغييرات بعد. ستظهر هنا أي تغييرات من باقي الأعضاء.",
    "notif.updated": "حدّث",
    "notif.new_updates": "تحديثات جديدة",
    "notif.push_on": "مُفعّل",
    "notif.push_off": "مُعطّل",
    "notif.push_enabled": "تم تفعيل إشعارات الخلفية",
    "notif.push_disabled": "تم إيقاف إشعارات الخلفية",
    "notif.push_denied": "تم حظر الإشعارات من إعدادات المتصفح.",
    "notif.push_failed": "تعذّر تفعيل الإشعارات.",
    "notif.unsupported": "إشعارات الخلفية غير مدعومة في هذا المتصفح. على آيفون، أضف التطبيق إلى الشاشة الرئيسية أولاً (iOS 16.4+).",
    "pedigree.title": "شجرة النسب",
    "pedigree.sub": "حتى ٣ أجيال. أضف حلقات الأب والأم في سجل الطيور لتمتد الشجرة.",
    "pedigree.placeholder": "رقم حلقة الطائر",
    "pedigree.show": "عرض الشجرة",
    "pedigree.enter": "أدخل رقم حلقة في الأعلى لعرض شجرة النسب.",
    "pedigree.notfound": "لا يوجد طائر بحلقة",
    "pedigree.unknown": "غير معروف",
    "reminders.title": "تذكيرات الفقس",
    "reminders.days_unit": "يومًا",
    "reminders.attention_one": "بيضة تحتاج إلى متابعة",
    "reminders.attention_other": "بيضات تحتاج إلى متابعة",
    "reminders.upcoming_one": "بيضة قادمة",
    "reminders.upcoming_other": "بيضات قادمة",
    "reminders.overdue": "متأخرة",
    "reminders.today": "اليوم",
    "reminders.in_days": "خلال",
    "reminders.enable": "تفعيل التنبيهات",
    "reminders.dismiss": "إخفاء",
    "settings.title": "إعدادات الموسم",
    "settings.sub_owner": "أعِد تسمية الموسم، اختر ألوانه ومدة الحضانة المستخدمة في تذكيرات الفقس.",
    "settings.sub_member": "فقط مالك الموسم يمكنه تعديل هذه الإعدادات.",
    "settings.name": "اسم الموسم",
    "settings.incubation": "مدة الحضانة",
    "settings.appearance": "المظهر",
    "settings.bg_color": "الخلفية",
    "settings.accent_color": "اللون المميز / لون الحلقة",
    "settings.use_hint": "اختر لونًا مختلفًا لكل موسم — كألوان الحلقات بين السنوات.",
    "settings.new_season": "إنهاء هذا الموسم وبدء موسم جديد",
    "settings.new_season_sub": "يُحفظ الموسم الحالي ويُفتح جدول جديد بنفس الأعضاء والألوان.",
    "settings.new_season_btn": "بدء موسم جديد…",
    "settings.new_season_title": "بدء موسم جديد",
    "settings.new_season_label": "اسم الموسم الجديد",
    "settings.new_season_placeholder": "مثلاً: موسم 2027",
    "settings.danger_zone": "منطقة الخطر",
    "settings.delete_group": "حذف هذا الموسم",
    "settings.delete_sub": "يحذف هذا الموسم وجداوله من التطبيق بشكل دائم. يمكن للمشرف استعادته عند الطلب.",
    "settings.delete_btn": "حذف الموسم…",
    "settings.delete_confirm_title": "هل تريد حذف هذا الموسم؟",
    "settings.delete_confirm_body": "سيؤدي هذا إلى حذف \"{name}\" وكل بيانات الأزواج والطيور والفراخ. يمكن للمشرف استعادته لاحقاً لكن الأعضاء سيفقدون الوصول فوراً. هل تريد المتابعة؟",
    "settings.delete_yes": "نعم، احذف",
    "settings.delete_no": "لا، احتفظ به",
    "members.title": "الأعضاء",
    "members.sub_owner": "أدر من له صلاحية الوصول إلى جداول هذا الموسم.",
    "members.sub_member": "يمكن للأعضاء عرض وتعديل جداول هذا الموسم.",
    "members.owner": "المالك",
    "members.remove": "إزالة",
    "members.transfer": "نقل الملكية",
    "members.leave": "مغادرة",
    "members.invite_more": "ادعُ مربّين آخرين",
    "members.remove_title": "إزالة العضو؟",
    "members.transfer_title": "نقل الملكية؟",
    "members.leave_title": "مغادرة هذا الموسم؟",
  },
};

export function buildTranslator(lang) {
  const dict = STRINGS[lang] || STRINGS.en;
  return (key, fallback) => dict[key] || fallback || key;
}

export function isRTL(lang) {
  return lang === "ar";
}
